export default __webpack_public_path__ + "static/media/1399.6e631301.png";